import { render } from "./AktuellesView.vue?vue&type=template&id=647ac3e0&scoped=true"
import script from "./AktuellesView.vue?vue&type=script&lang=js"
export * from "./AktuellesView.vue?vue&type=script&lang=js"

import "./AktuellesView.vue?vue&type=style&index=0&id=647ac3e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647ac3e0"]])

export default __exports__